import { defineStore } from 'pinia';
import cookie from '@nextories/vue-core-components/src/utils/helpers/cookie';
import notificationWrapper from '@/utils/helpers/notificationWrapper';
import offersHelper from '@/utils/helpers/offers';
import { useProjectStore } from './projectStore';
import type { Offer } from '@/types/Offers';

export const useComparatorStore = defineStore('comparator', {
  state: () => ({
    offer: {},
    isSigningModalDisplayed: false,
    signature: null,
    signatureLoading: false,
    stripeToken: null,
    stripeTokenLoading: false,
    prebookDate: null,
  }),

  actions: {
    displaySigningModal(offer: Offer) {
      const projectStore = useProjectStore();
      cookie.setCookie(
        import.meta.env.VITE_APP_COOKIE_REDIRECT_NAME,
        projectStore.projectIdSelected,
        1,
      );
      this.setOffer(offer);
      this.isSigningModalDisplayed = true;
    },

    hideSigningModal() {
      this.setOffer({});
      this.isSigningModalDisplayed = false;
    },

    async activateSignature(offer: any) {
      try {
        const projectStore = useProjectStore();
        const data = await window.appConnector.activateSignature(projectStore.projectIdSelected);
        if (data) {
          offer.signing_procedure = data;
          this.setOffer(offer);
        }
        return data;
      } catch (error) {
        notificationWrapper('error', error.isAuthenticationError
          ? 'NOT_LOGGED'
          : 'DEFAULT');
        throw error;
      }
    },

    async getSignature() {
      this.signatureLoading = true;
      try {
        const projectStore = useProjectStore();
        const data = await window.appConnector.getSignature(projectStore.projectIdSelected);
        if (data) {
          this.signature = data;
          this.signatureLoading = false;
        }
        return data;
      } catch (error) {
        notificationWrapper('error', error.isAuthenticationError
          ? 'NOT_LOGGED'
          : 'DEFAULT');
        this.signatureLoading = false;
        throw error;
      }
    },

    async getStripeToken() {
      this.stripeTokenLoading = true;
      try {
        const data = await window.appConnector.getStripeToken();
        if (data) {
          this.stripeToken = data.secret;
          this.stripeTokenLoading = false;
        }
        return data;
      } catch (error) {
        notificationWrapper();
        this.stripeTokenLoading = false;
        throw error;
      }
    },

    setOffer(offer: Offer) {
      const projectStore = useProjectStore();
      this.offer = offersHelper.formatOffer(offer, projectStore.projectSelected);
    },

    setPrebookDate(date: string) {
      this.prebookDate = date;
    },
  },
});
